import Hex from 'crypto-js/enc-hex'
import SHA1 from 'crypto-js/sha1'
import SHA256 from 'crypto-js/sha256'
import AESGCM from './crypto/aes-gcm'

/**
 * 加密
 * @param text 文本
 * @param key 秘钥
 * @return {Promise<string>}
 */
async function encrypt(text, key) {
  if (typeof text !== 'string') {
    text = JSON.stringify(text)
  }
  return AESGCM.encrypt(text, key).catch(() => '')
}

/**
 * 解密
 * @param text 文本
 * @param key 秘钥
 * @returns {Promise<string>}
 */
async function decrypt(text, key) {
  if (typeof text !== 'string') {
    text = JSON.stringify(text)
  }
  return AESGCM.decrypt(text, key).catch(() => '')
}

function tellerEncrypt(text, key) {
  return encrypt(text, key)
}
function tellerGetRealKey(key) {
  let encrypted = SHA1(SHA1(key))
  return encrypted.toString().substring(0, 32)
}
export function generateSalt(length = 32) {
  let len = Math.max(0, parseInt(length, 10) || 32)
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    let bytes = new Uint8Array((len + 1) >> 1)
    crypto.getRandomValues(bytes)
    return Array.from(bytes, b => b.toString(16).padStart(2, '0'))
      .join('')
      .slice(0, len)
  }
  return Array.from({ length: len }, () =>
    ((Math.random() * 16) | 0).toString(16)
  ).join('')
}

export function getSha256Hash(password, salt, nonce) {
  if (nonce) {
    return SHA256(
      SHA256(String(password) + String(salt)).toString(Hex) + nonce
    ).toString(Hex)
  }
  return SHA256(String(password) + String(salt)).toString(Hex)
}

export default {
  encrypt,
  decrypt,
  tellerEncrypt,
  tellerGetRealKey,
  generateSalt,
  getSha256Hash
}
